export const parisSubRegions = [
  'PARIS(75)',
  'Asnieres Sur Seine',
  'Boulogne Billancourt',
  'Cachan',
  'Clamart',
  'Clichy',
  'Courbevoie',
  'Issy Les Moulineaux',
  'Malakoff',
  'Massy',
  'Montrouge',
  'Nanterre',
  'Ouen Sur Seine',
  'Palaiseau',
  'Serris',
  'Vanves',
  'Villejuif'
];

export const parisResidencesBySubRegion = {
  'PARIS(75)': ['Nexity Studea Daumesnil', 'Nexity Studea Jean Cocteau', 'Nexity Studea Paris', 'Nexity Studea Paris Bastille', 'Nexity Studea Paris Davout', 'Nexity Studea Paris Grande Bibliothèque', 'Nexity Studea Rive Gauche'],
  'Asnieres Sur Seine': ['Nexity Studea Asnieres'],
  'Boulogne Billancourt': ['Nexity Studea Boulogne Seguin'],
  'Cachan': ['Nexity Studea Cachan'],
  'Clamart': ['Nexity Studea Clamart'],
  'Clichy': ['Nexity Studea Hauts De Seine'],
  'Courbevoie': ['Nexity Studea Grande Arche', 'Nexity Studea Leonard Da Vinci', 'Nexity Studea Lilas D\'espagne'],
  'Issy Les Moulineaux': ['Nexity Studea Issy', 'Nexity Studea Issy 2', 'Nexity Studéa Porte D\'Issy'],
  'Malakoff': ['Nexity Studea Malakoff'],
  'Massy': ['NexityStudea Massy'],
  'Montrouge': ['Nexity Studea Porte D\'orleans'],
  'Nanterre': ['Nexity Studea Nanterre Joffre'],
  'Ouen Sur Seine': ['Nexity Studea St Ouen 1', 'Nexity Studea St Ouen 2'],
  'Palaiseau': ['Nexity Studea Palaiseau Centre'],
  'Serris': ['Nexity Studea Val D Europe 1', 'Nexity Studea Val D\'europe 2'],
  'Vanves': ['Nexity Studea Vanves Bleuzen', 'Nexity Studea Vanves J.monnet', 'Nexity Studea Vanves Marcheron'],
  'Villejuif': ['Nexity Studea Villejuif Centre']
};

export const residencesByCity = {
  'Aix En Provence': ['Nexity Studea Aix Centre', 'Nexity Studea Aix Galice', 'Nexity Studea Republique'],
  'Amiens': ['Nexity Studea Amiens Centre'],
  'Angers': ['Nexity Studea Saint-serge'],
  'Bagnolet': ['Nexity Studea Bagnolet'],
  'Bordeaux': ['Nexity Studea Bordeaux Centre 1', 'Nexity Studea Bordeaux Centre 2', 'Nexity Studea Bordeaux Centre 3', 'Nexity Studea Bordeaux Chartrons', 'Nexity Studea Bordeaux Bastide', 'Nexity Studea Bordeaux West'],
  'Cergy': ['Nexity Studea Cergy Universite 1', 'Nexity Studea Cergy Universite 2'],
  'Chelles': ['Nexity Studea Chelles Gare RER'],
  'Grenoble': ['Nexity Studea Carre Des Halles', 'Nexity Studea Grenoble Centre', 'Nexity Studea Louis Weil'],
  'Joinville Le Pont': ['Nexity Studea Joinville Center'],
  'Le Pre St Gervais': ['Nexity Studea Pre St Gervais'],
  'Lille': ['Nexity Studea Lille Centre', 'Nexity Studea Lille Scientific City', 'Nexity Studea Lille I', 'Nexity Studea Moulin', 'Nexity Studea Novalille'],
  'Lyon': ['Nexity Studea Claude Bernard 2', 'Nexity Studea Garibaldi Berthelot', 'Nexity Studea Jean Jaures 2', 'Nexity Studea Jean Mace', 'Nexity Studea Lyon Confluence', 'Nexity Studea Lyon Ouest 2', 'Nexity Studea Lyon Vaise', 'Nexity Studea Massena 1', 'Nexity Studea Massena 2', 'Nexity Studea Porte Des Alpes 2', 'Nexity Studea Presqu\'ile', 'Nexity Studea Saxe-Gambetta', 'Nexity Studea Université 1', 'Nexity Studea Charpennes 1', 'Nexity Studea La Doua', 'Nexity Studea Montchat', 'Nexity Studea Villeurbanne Republique 1', 'Nexity Studea Villeurbanne Republique 2'],
  'Marseille': ['Nexity Studea Euromediterranee', 'Nexity Studea Euromediterranee 2', 'Nexity Studea Marseille Capelette', 'Nexity Studea Marseille Croix D\'azur', 'Nexity Studea Marseille Ferrari', 'Nexity Studea Marseille Timone'],
  'Montpellier': ['Nexity Studea Euromedecine', 'Nexity Studea Montferrand', 'Nexity Studea Montpellier Millenaire', 'Nexity Studea Paul Valery 2', 'Nexity Studea Zuccarelli'],
  'Nantes': ['Nexity Studea Ile Beaulieu', 'Nexity Studea Loquidy', 'Nexity Studea Yleo'],
  'Nice': ['Nexity Studea California', 'Nexity Studea Nice Centre', 'Nexity Studea Nice Valrose', 'Nexity Studea Riquier'],
  'Perpignan': ['Nexity Studea Perpignan'],
  'Rennes': ['Nexity Studea Atalante'],
  'Roubaix': ['Nexity Studea Roubaix', 'Nexity Studea Roubaix Parc Barbieux'],
  'Rouen': ['Nexity Studea Rouen Constantine', 'Nexity Studea Rouen Prefecture'],
  'Serris': ['Nexity Studea Val D Europe 1', 'Nexity Studea Val D\'europe 2'],
  'Sevres': ['Nexity Studea Sevres'],
  'Strasbourg': ['Nexity Studea Strasbourg Rieth', 'Nexity Studea Strasbourg Rieth 2', 'Nexity Studea Winston 2'],
  'Talence': ['Nexity Studea Talence'],
  'Toulouse': ['Nexity Studea Toulouse Cartoucherie', 'Nexity Studea Toulouse Compans Caffarelli', 'Nexity Studea Toulouse West', 'Nexity Studea Toulouse Purpan', 'Nexity Studea Toulouse Rangueil'],
  'Tours': ['Nexity Studea Gare'],
  'Valbonne': ['Nexity Studea Sophia Antipolis'],
  'Valenciennes': ['Nexity Studea Valenciennes Mont Houy']
};

export const cities = Object.keys(residencesByCity).concat('Paris');
